import { Outlet } from "react-router-dom";
import { sidebarListReseller } from "../../constants/sidebarList";
import { ProtectedRoute } from "../../middleware/ProtectedRoute";
import { ContentDashboardContainer } from "../container/ContentDashboardContainer";
import { DashboardContainer } from "../container/DashboardContainer";

export const LayoutDashboardReseller = () => {
  return (
    <ProtectedRoute userType="reseller">
      <DashboardContainer data={sidebarListReseller} pageRoot="/reseller">
        <ContentDashboardContainer>
          <Outlet />
        </ContentDashboardContainer>
      </DashboardContainer>
    </ProtectedRoute>
  );
};
